import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: theme => ({
    marginHorizontal: 16.6,
    flexDirection: 'row',
    borderBottomColor: theme.colors.VFDivider.primary,
    borderBottomWidth: 1,
    marginBottom: 8,
  }),
  balanceIconViewStyle: {
    paddingTop: 10,
    marginRight: 18,
  },
  rightblock: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
  },
  itemDataViewStyle: {
    flexDirection: 'row',
    marginTop: 8,
    marginBottom: 9,
    paddingBottom: 5,
    flexGrow: 1,
    justifyContent: 'space-between',
  },
  balanceTitleStyle: theme => ({
    fontSize: 18.7,
    lineHeight: 25,
    color: theme.colors.textColorThree,
  }),
  balanceItemDate: theme => ({
    fontSize: 14.6,
    lineHeight: 18.7,
    color: theme.colors.textColorTwo,
  }),
  balanceItemPrice: theme => ({
    fontSize: 18,
    lineHeight: 24,
    color: theme.colors.textColorThree,
  }),
  balanceItemPriceTopUp: theme => ({
    fontSize: 18,
    lineHeight: 24,
    color: theme.colors.textColorThree,
  }),
});
